import {Box, Typography} from "@mui/material";

export interface DetailsHeaderProps {
    children: React.ReactNode;
}

export function DetailsHeader(props: Readonly<DetailsHeaderProps>) {
    return (
        <Box mb={2}>
            <Typography variant={"h5"}>{props.children}</Typography>
        </Box>
    );
}